import { useInjection } from 'inversify-react';
import { useEffect, useState } from 'react';

import { Page } from '@desygner/ui-features-projects';

import { PageManager } from '../../core/viewer/page-manager';
import { TYPES } from '../../inversify.types';

type UseLoadPageContentParams = {
  pageId: number;
  page: Page;
};

export const useLoadPageContent = ({ pageId, page }: UseLoadPageContentParams) => {
  const [isProcessingPageContent, setIsProcessingPageContent] = useState(true);
  const pageManager = useInjection<PageManager>(TYPES.Viewer.PageManager);

  useEffect(() => {
    (async () => {
      await pageManager
        .loadPageContent({
          pageId,
          page,
        })
        .finally(() => {
          setIsProcessingPageContent(false);
        });
    })();
  }, [pageManager, pageId]);

  return {
    isProcessingPageContent,
  };
};
